module.exports = __webpack_public_path__ + "img/template2.df56d747.jpg";